import { connect } from 'react-redux'
import PageCompany from './PageCompany.component'
import { loadDirectors, loadClients } from '../../actions/enterprise'
import { loadAllBrokers } from '../../actions/brokers'

const mapStateToProps = (state) => {
  return {
    clients: state.enterprise.clients,
    directors: state.enterprise.directors,
    subsidiaries: state.subsidiaries.list,
    sectors: state.app.sectors,
    brokers: state.brokers.list,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
     loadDirectors: () => dispatch(loadDirectors()),
     loadClients: () => dispatch(loadClients()),
     loadBrokers: () => dispatch(loadAllBrokers()),
  }
}

const Enterprise = connect(
  mapStateToProps,
  mapDispatchToProps
)(PageCompany)

export default Enterprise


// WEBPACK FOOTER //
// ./src/features/PageCompany/PageCompany.container.js